import { render, staticRenderFns } from "./WorldSlide.vue?vue&type=template&id=0e5a003c&scoped=true"
import script from "./WorldSlide.vue?vue&type=script&lang=js"
export * from "./WorldSlide.vue?vue&type=script&lang=js"
import style0 from "./WorldSlide.vue?vue&type=style&index=0&id=0e5a003c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a003c",
  null
  
)

export default component.exports